import { Box, Button, Container, CssBaseline, Icon } from '@mui/material';
import React, { useContext } from 'react';
import { AuthContext, ConferenceContext } from '@/store';
import LoginBox from './loginbox';

export const AuthWall = (props) => {
  const { authState } = useContext(AuthContext);
  const { conferenceState } = useContext(ConferenceContext);
  return !authState.userLoggedIn ||
    conferenceState.conferenceDetailProgress ||
    (conferenceState.conferenceDetail &&
      !conferenceState.conferenceDetail.fullInfo) ? (
    <Box>
      <CssBaseline />
      <Container maxWidth="xs">
        <Box>
          <Button color="inherit" startIcon={<Icon>home</Icon>} href="/">
            {window.LANG.HOME}
          </Button>
        </Box>
        <LoginBox />
      </Container>
    </Box>
  ) : (
    props.children
  );
};
